import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  ColorPickerComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import Message from '../../../utils/Message/Message';
interface IState {
  Data: Array<any>;
}
interface IProps {}
export class ShiftWorkbenchStatus extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private dropDownListObjectStatusColor: any;
  public validationRule: Object = { required: true };
  private type: string = 'workbenchstatus';
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      Data: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    'Search',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  componentDidMount() {
    this.getWorkbenchStatus(this.type);
  }
  async getWorkbenchStatus(type: string) {
    getShiftWorkbenchSettings(type).then((res) => {
      this.setState({ Data: res.data });
    });
  }
  actionBeginStatus(args: any) {
    if (args.actıon === 'refresh') {
      this.getWorkbenchStatus(this.type);
    }
    if (args.action === 'add') {
      this.savePointAddStatus(args.data);
    } else if (args.action === 'edit') {
      this.savePointEditStatus(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDeleteStatus(args.data);
    }
  }
  savePointAddStatus(obje: any) {
    loadingShow(true);
    let color = this.dropDownListObjectStatusColor.value;
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      status_code: obje.status_code === undefined ? '' : obje.status_code,
      status_description:
        obje.status_description === undefined ? '' : obje.status_description,
      status_alias: obje.status_alias === undefined ? '' : obje.status_alias,
      status_color: color === (null || undefined) ? '' : color,
      created_by: all_information.user_id,
      type: this.type,
    });
    AddShiftWorkbenchSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchStatus(this.type);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEditStatus(obje: any) {
    let color = this.dropDownListObjectStatusColor.value;
    loadingShow(true);
    const obj = JSON.stringify({
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      status_code: obje.status_code === undefined ? '' : obje.status_code,
      status_description:
        obje.status_description === undefined ? '' : obje.status_description,
      status_alias: obje.status_alias === undefined ? '' : obje.status_alias,
      status_color: color === (null || undefined) ? '' : color,
      id: obje.id,
      type: this.type,
    });
    EditShiftWorkbenchSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchStatus(this.type);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDeleteStatus(obje: any) {
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        Message.success('Success');
        loadingShow(false);
        this.getWorkbenchStatus(this.type);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  private colorEditTemplate(args: any) {
    return (
      <ColorPickerComponent
        value={args.status_color}
        ref={(scope) => (this.dropDownListObjectStatusColor = scope)}
      />
    );
  }
  private colorTemplate(args: any) {
    return <ColorPickerComponent value={args.status_color} disabled />;
  }
  render() {
    return (
      <GridComponent
        id='gridShiftworkbenchAssetStatus'
        editSettings={this.editOptions}
        toolbar={this.toolbarOptions}
        dataSource={this.state.Data}
        height='calc(-220px + 100vh)'
        ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
        filterSettings={this.FilterOptions}
        allowFiltering={true}
        allowPaging={true}
        pageSettings={this.pageOptions}
        allowExcelExport
        showColumnMenu={true}
        allowResizing={true}
        allowGrouping={true}
        actionBegin={this.actionBeginStatus.bind(this)}
        gridLines='Both'
      >
        <ColumnsDirective>
          <ColumnDirective
            field='status_code'
            headerText='Status Code'
            validationRules={this.validationRule}
            textAlign='Left'
          />
          <ColumnDirective
            field='status_description'
            headerText='Description'
            textAlign='Left'
          />
          <ColumnDirective
            field='status_alias'
            headerText='Alias'
            validationRules={this.validationRule}
            textAlign='Left'
          />
          <ColumnDirective
            field='status_color'
            headerText='Color'
            textAlign='Left'
            width={50}
            template={this.colorTemplate.bind(this)}
            editTemplate={this.colorEditTemplate.bind(this)}
          />
        </ColumnsDirective>
        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            Page,
            ColumnMenu,
            Resize,
            ColumnChooser,
            ExcelExport,
            Group
          ]}
        />
      </GridComponent>
    );
  }
}

export default ShiftWorkbenchStatus;
